import Templater from '@hc-frontend/shared-assets/src/js/utils/dom/Templater'
import toHtmlClass from '../coverageDetails/toHtmlClass'
import innerHTML from 'utils/DOM/innerHTML'
import getById from 'utils/DOM/getById'

function renderLatitudeDetails(plan) {
  const templateMenu = Templater(getById('template-coverage-menu').innerText)
  const templateDetail = Templater(getById('template-coverage').innerText)
  const menu = []
  const details = []

  plan.benefits.forEach(benefit => {
    const data = {
      ...benefit,
      id: `latitude-${benefit.headline.toLowerCase().replace(/\W/g, '-')}`,
      show: 'show',
      expanded: 'true'
    }
    menu.push(templateMenu(data))
    details.push(templateDetail(data, { toHtmlClass }))
  })

  innerHTML(getById('coverage__menu-latitude--nav'), menu.join(''))

  innerHTML(getById('coverage__list-latitude'), details.join(''))
}

export default renderLatitudeDetails
